export default (that) => [
  {
    type: 'seq',
    title: '#',
    width: 50,
    fixed: 'left',
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    width: 80,
    fixed: 'right',
    slots: { default: 'opt' },
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'planNo',
    title: that.$l('form_label_planNos') || '补货计划编号',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'planNoHeader' },
  },
  {
    field: 'fbaDc',
    title: that.$l('table_label_fbaDc') || 'FBA DC',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'fbaDcHeader' },
  },
  {
    field: 'fbaId',
    title: that.$l('table_label_fbaId') || 'FBA ID',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'fbaIdHeader' },
  },
  {
    field: 'fbaIdReferenceId',
    title: that.$l('table_label_fbaIdReferenceId') || 'FBA Reference ID',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'fbaIdReferenceIdHeader' },
  },
  {
    field: 'amzSkuNo',
    title: that.$l('table_label_sku') || 'SKU',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'amzSkuNoHeader' },
  },
  {
    field: 'amzStoreSkuNo',
    title: that.$l('table_label_storeSku') || '店铺 SKU',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'amzStoreSkuNoHeader' },
  },
  {
    field: 'goodsName',
    title: that.$l('table_label_goodsName') || '产品名称',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'goodsNameHeader' },
  },
  {
    field: 'goodsColor',
    title: that.$l('table_label_goodsColor') || '颜色',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'goodsColorHeader' },
  },
  {
    field: 'ncNo',
    title: that.$l('table_label_ncNo') || 'NC编号',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'ncNoHeader' },
  },
  {
    field: 'storeName',
    title: that.$l('table_label_storeName') || '店铺名称',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'storeNameHeader' },
  },
  {
    field: 'amzReplenishmentNo',
    title: that.$l('table_label_amzReplenishmentNo') || '补货单号',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'amzReplenishmentNoHeader' },
  },
  {
    field: 'qty',
    title: that.$l('table_label_goodsQty') || '数量',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'ctnQty',
    title: that.$l('table_label_ctnQty') || '箱数',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'inCtnQty',
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'ctnGrossWeight',
    title: that.$l('table_label_singleGrossWeight') || '单箱毛重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'ctnNetWeight',
    title: that.$l('table_label_singleNetWeight') || '单箱净重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalGrossWeight',
    title: that.$l('table_label_totalGrossWeight') || '总毛重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalNetWeight',
    title: that.$l('table_label_totalNetWeight') || '总净重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'ctnVolume',
    title: that.$l('table_label_singleVolume') || '单箱体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalVolume',
    title: that.$l('table_label_totalVolume') || '总体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'goodsSize',
    title: that.$l('table_label_goodsSize') || '规格/尺寸',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'materialInfo',
    title: that.$l('table_label_materialInfo') || '产品材质',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'goodsReadyDate',
    title: that.$l('table_label_goodsReadyDate') || '货好时间',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'goodsReadyDateHeader' },
  },
  {
    field: 'customerDeliveryDate',
    title: that.$l('table_label_customerDeliveryDate') || '客户交期',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'customerDeliveryDateHeader' },
  },
  {
    field: 'loadingDate',
    title: that.$l('table_label_loadingDate') || '产装日期',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'loadingDateHeader' },
  },

  {
    field: 'scmName',
    title: that.$l('table_label_scmName') || '出货工厂',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'scmNameHeader' },
  },
  {
    field: 'ecomWarehouseName',
    title: that.$l('table_label_ecomWarehouseName') || '出货仓库',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'ecomWarehouseNameHeader' },
  },
  {
    field: 'invoiceFactoryName',
    title: that.$l('table_label_invoiceFactoryName') || '开票工厂',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'invoiceFactoryNameHeader' },
  },
  {
    field: 'shippingFactoryName',
    title: that.$l('table_label_shippingFactoryName') || '送货工厂',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'shippingFactoryNameHeader' },
  },
  {
    field: 'hscode',
    title: that.$l('table_label_hscode') || '报关HSCODE',
    minWidth: 130,
    slots: { header: 'hscodeHeader' },
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'hscodeName',
    title: that.$l('table_label_hscodeName') || '报关中文品名',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'hscodeNameHeader' },
  },
  {
    field: 'hscodeNameEn',
    title: that.$l('table_label_hscodeNameEn') || '报关英文品名',
    minWidth: 180,
    slots: { header: 'hscodeNameEnHeader' },
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'customsPrice',
    title: that.$l('table_label_customsPrice') || '报关单价',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'originalPlace',
    title: that.$l('table_label_originalPlace') || '境内货源地',
    minWidth: 140,
    slots: { header: 'originalPlaceHeader' },
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'declarationElements',
    title: that.$l('table_label_declarationElements') || '申报要素',
    minWidth: 280,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'unitCost',
    title: that.$l('table_label_unitCost') || '成本单价',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) =>
      [row.unitCost || '0', row.costCurrencyUnitName || row.costCurrencyUnit]
        .filter(Boolean)
        .join(' '),
  },
  {
    field: 'unitSellingPrice',
    title: that.$l('table_label_unitSellingPrice') || '销售单价',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) =>
      [
        row.unitSellingPrice || '0',
        row.salesCurrencyUnitName || row.salesCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' '),
  },
  {
    field: 'costAmount',
    title: that.$l('table_label_costAmount') || '成本金额',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) =>
      [row.costAmount || '0', row.costCurrencyUnitName || row.costCurrencyUnit]
        .filter(Boolean)
        .join(' '),
  },
  {
    field: 'salesAmount',
    title: that.$l('table_label_salesAmount') || '销售金额',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) =>
      [
        row.salesAmount || '0',
        row.salesCurrencyUnitName || row.salesCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' '),
  },
]
